import {Pipe, PipeTransform} from '@angular/core';
import {filterByField} from "@utility";

@Pipe({
    name: 'filterByField',
    standalone: false
})
export class FilterByFieldPipe implements PipeTransform {

  transform(items: any[] | undefined, field: string, value: any, differentThanValue?: boolean | undefined): any[] {
    return filterByField(items, field, value, differentThanValue)
  }
}
